// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/tab/index.css
// module id = 188
// module chunks = 1